import styled from 'styled-components';

import { px } from '../../../../../../contrib/ui';

export const StyledGameFormatSelector = styled.div`
  background-color: white;

  p {
    color: var(--grey87);
    font-family: 'DINNextLTPro-Medium';
    text-transform: uppercase;
    margin: 0;
    font-size: ${px(16)};
  }

  ul.unselected-round-formats {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-bottom: ${px(40)};

    .icon.override {
      height: ${px(24)};
      width: ${px(24)};
      color: var(--mainColor);
      transition: all 0.1s ease-in-out;
    }

    .name {
      text-transform: uppercase;
      color: var(--mainColor);
      font-family: 'DINNextLTPro-Heavy';
      font-size: ${px(16)};
      line-height: ${px(19)};
      padding: ${px(4)} 0 0 ${px(12)};
      transition: all 0.1s ease-in-out;
    }

    li.unselected-round-format {
      border: none;
      border-radius: 0;
      box-shadow: none;
      padding: 0;
      margin-top: ${px(10)};
      cursor: pointer;
      margin-top: calc(var(--px) * 10);

      display: flex;
      align-items: center;

      span.name {
        color: var(--dark);
      }

      &.disabled {
        cursor: no-drop;
        .icon.override {
          color: var(--grey87);
        }
        span.name {
          color: var(--grey87);
        }
      }

      &.selected {
        cursor: no-drop;
        .icon.override {
          color: var(--teal);
        }
      }
    }
  }

  flex-basis: ${px(393)};
  padding-right: ${px(23)};
  max-width: ${px(355)};

  > p {
    color: var(--dark);
    font-family: 'DINNextLTPro-Bold';
    font-size: ${px(16)};
    line-height: ${px(26)};
  }
`;
